package pl.michal_cyran.brand_hub.subpages.tutoring.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseIn
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.H4
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.IconBoxStyle
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware

@Composable
fun OfferCard(
    title: String,
    description: String,
    icon: @Composable ((size: IconSize) -> Unit),
    modifier: Modifier = Modifier,
    index: Int = 0,
) {
    VisibilityAware(
        modifier = CardStyle.toModifier()
            .padding(20.px) // Lekko zwiększony padding dla lepszego "oddechu" tekstu
            .fillMaxWidth()
            // ZMIANA: Usunięto sztywne .height(150.px), karta dopasuje się do długości tekstu
            .then(modifier)
    ) { isVisible ->
        Box(
            Modifier
                .opacity(if (isVisible) 1 else 0)
                .transform { translateX(if (isVisible) 0.px else (-30).px) }
                .transition(
                    Transition.of("opacity", 0.5.s, EaseOut, (index * 120).ms),
                    Transition.of("transform", 0.5.s, EaseOut, (index * 120).ms)
                )
        ) {
            Row(
                // ZMIANA: Wyrównanie ikony i tekstu do góry (Top), by przy długim tekście układ wyglądał spójnie
                verticalAlignment = Alignment.Top,
                horizontalArrangement = Arrangement.spacedBy(1.25.cssRem), // Delikatnie większy odstęp między ikoną a tekstem
                modifier = Modifier.fillMaxWidth()
            ) {
                Box(
                    modifier = IconBoxStyle.toModifier()
                        // ZMIANA: Zapewnienie, że kontener na ikonę nie skurczy się przy długim tekście obok
                        .flexShrink(0)
                        .transform { scale(if (isVisible) 1.0 else 0.5) }
                        .transition(
                            Transition.of("transform", 0.4.s, EaseIn, (index * 120 + 150).ms)
                        )
                ) {
                    icon(IconSize.XXL)
                }

                Column(
                    // ZMIANA: flexGrow(1) pozwala tekstowi zająć całą pozostałą przestrzeń w karcie
                    modifier = Modifier.fillMaxWidth().flexGrow(1),
                    verticalArrangement = Arrangement.spacedBy(0.5.cssRem) // Zmniejszony wewnętrzny odstęp między nagłówkiem a opisem
                ) {
                    H4(
                        Modifier.margin(top = 0.px, bottom = 0.px).toAttrs()
                    ) {
                        Text(title)
                    }
                    P(
                        Modifier.margin(top = 0.px, bottom = 0.px)
                            .lineHeight(1.5.cssRem)
                            .toAttrs()
                    ) {
                        Text(description)
                    }
                }
            }
        }
    }
}